export const defaultFontSetting = {
  fontFamily: "PingFang SC",
  fontWeight: 600,
  fontSize: 16,
  fontStyle: "normal",
  letterSpacing: 1,
  letterSpacingType: undefined,
  lineHeight: 23,
  lineHeightType: undefined,
  textAlign: "left",
  textDecoration: "none",
  writingMode: "horizontal",
  fontColor: {
    type: 'color',
    color: '#000',
    data: {
      angle: 0,
      stops: [
        ['#000', 0, {
          colorOpacity: 100,
          isThemeColor: false,
          themeColorId: 0,
        },],
        ['#000', 1, {
          colorOpacity: 100,
          isThemeColor: false,
          themeColorId: 0,
        },]
      ]
    },
    isThemeColor: false,
    colorOpacity: 100,
    themeColorId: 0
  }
}

export const defaultSimpleFontSetting = {
  fontWeight: 600,
  fontSize: 16,
  fontColor: {
    type: 'color',
    color: '#000',
    data: {
      angle: 0,
      stops: [
        ['#000', 0, {
          colorOpacity: 100,
          isThemeColor: false,
          themeColorId: 0,
        },],
        ['#000', 1, {
          colorOpacity: 100,
          isThemeColor: false,
          themeColorId: 0,
        },]
      ]
    },
    isThemeColor: false,
    colorOpacity: 100,
    themeColorId: 0
  },
  fontFamily: "PingFang SC",
  textIsThemeColor: false,
  colorMode: 'simple',
  colorArr: {
    type: 'color',
    color: '#000',
    data: {
      angle: 0,
      stops: [
        ['#000', 0, {
          colorOpacity: 100,
          isThemeColor: false,
          themeColorId: 0,
        },],
        ['#000', 1, {
          colorOpacity: 100,
          isThemeColor: false,
          themeColorId: 0,
        },]
      ]
    },
    isThemeColor: false,
    colorOpacity: 100,
    themeColorId: 0
  }
} 

export const defaultComplexFontSetting = {
  fontFamily: "PingFang SC",
  fontWeight: 400,
  fontSize: 16,
  fontStyle: "normal",
  letterSpacing: 1,
  letterSpacingType: undefined,
  lineHeight: 23,
  lineHeightType: "px",
  textAlign: "left",
  textDecoration: "none",
  writingMode: "horizontal-tb",
  textIsThemeColor: false,
  shadowH: [],
  shadowV: [],
  shadowBlur: [],
  shadowColor: [],
  fontColor: {
    type: 'color',
    color: '#000',
    data: {
      angle: 0,
      stops: [
        ['#000', 0, {
          colorOpacity: 100,
          isThemeColor: false,
          themeColorId: 0,
        },],
        ['#000', 1, {
          colorOpacity: 100,
          isThemeColor: false,
          themeColorId: 0,
        },]
      ]
    },
    isThemeColor: false,
    colorOpacity: 100,
    themeColorId: 0
  }
}

export const defaultPaddingSetting = {
  paddingTypeFlag: 1,
  padding: 0,
  paddingTop: 0,
  paddingRight: 0,
  paddingLeft: 0,
  paddingBottom: 0,
  sliderMax: 500
}

export const defaultBoxShadowSetting = {
  boxShadowColor: [],
  boxShadowH: [],
  boxShadowV: [],
  boxShadowBlur: [],
  boxShadowSpread: [],
}

export const defaultBorderRadiusSetting = {
  borderTypeFlag: 2,
  borderRadius: 0,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderBottomLeftRadius: 0,
  sliderMax: 500
}

export const defaultBorderSetting = {
  showEnableCheckbox: false,
  enable: false,
  borderStyle: "solid",
  borderWidth: [0, 0, 0, 0],
  borderColor: {
    color: "rgba(10, 107, 255, 1)", 
    type: "color", 
    label: "颜色", 
    data: {
      angle: 0,
      stops: [["rgba(10, 107, 255, 1)", 1, {
        colorOpacity: 100,
        isThemeColor: false,
        themeColorId: 0,
      },], ["rgba(10, 107, 255, 1)", 1, {
        colorOpacity: 100,
        isThemeColor: false,
        themeColorId: 0,
      },]]
    },
    isThemeColor: false,
    colorOpacity: 100,
    themeColorId: 0
  }
}


export const defaultBackgroundSetting = [
  {
    type: "color",
    color: "#fff",
    data: {
      angle: 0,
      stops: [["#fff", 1, {
        colorOpacity: 100,
        isThemeColor: false,
        themeColorId: 0,
      },], ["#fff", 1, {
        colorOpacity: 100,
        isThemeColor: false,
        themeColorId: 0,
      }]]
    },
    isThemeColor: false,
    colorOpacity: 100,
    themeColorId: 0
  }
]

export const defaultIconSetting = {
  showIcon: false,
  iconSrc: "5CB4CFFC9CE56FF2",
  iconType: "icon",
  iconWidth: 14,
  iconMargin: 10,
  iconColor: "#000",
  iconColorIsThemeColor: false,
  iconPosition: 'left',
  resInfo: {}
}

export const defaultSizeSetting = {
  widthVal: 50,
  widthAuto: false,
  widthFull: false,
  heightVal: 50,
  heightAuto: false
}

export const defaultColorSetting = {
  type: 'color',
  color: 'rgba(10, 107, 255, 1)',
  data: {
    angle: 0,
    stops: [
      ['rgba(10, 107, 255, 1)', 0, {
        colorOpacity: 100,
        isThemeColor: false,
        themeColorId: 0,
      },],
      ['rgba(10, 107, 255, 1)', 1, {
        colorOpacity: 100,
        isThemeColor: false,
        themeColorId: 0,
      }]
    ]
  },
  isThemeColor: false,
  colorOpacity: 100,
  themeColorId: 0
}

export const defaultCheckBoxGroupSetting = {
  checkBoxValue: [],
  checkBoxList: [{
    label: 0,
    value: "选项一"
  }]
}

export const defaultDivideSetting = {
  showDivide: false,
  divideType: "line",
  divideIconColor: "rgba(0,0,0,0.2)",
  divideResInfo: {},
  divideIconSrc: "",
  divideIconType: "icon",
  divideIconColorIsThemeColor: false,
  divideWidth: 1,
  divideHeight: 24,
  iconColorIsThemeColor: false
}

export const defaultSelectSetting = {
  selectOptions: [],
  showTooltip: false,
  showIcon: false,
  selectDirection: "",
  toolTipValue: "label",
  tooltipPosition: "top",
  title: "",
  titleSize: "auto",
  appendToBody: false,
  maxTextSize: 10,
  value: ""
}